<template>
  <div class="gap-filler-input" :class="{ [status]: true, 'show-status': showAnswers }">
    <input type="number" ref="input" :value="value" @input="inputValue($event.target.value)">
  </div>
</template>

<script>
export default {
  name: 'GapFillerInput',
  props: {
    value: {
      type: String,
      required: true
    },
    showAnswers: {
      type: Boolean,
      required: true
    },
    goodAnswer: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      valueChanged: false
    }
  },
  computed: {
    status () {
      return Number(this.value.replace(',', '.')) === this.goodAnswer
        ? 'right'
        : 'wrong'
    }
  },
  methods: {
    inputValue (val) {
      this.$emit('input', val)
      this.$emit('touched')
      this.$refs.input.classList.add('touched')
    }
  },
  watch: {
    valueChanged: function () {
      if (this.$refs.input) {
        this.$refs.input.classList.remove('touched')
      }
    }
  }
}
</script>

<style lang="scss">
.gap-filler-input {
  line-height: 36px;
  display: inline-block;
  vertical-align: middle;
  position: relative;
  margin: 0 15px;
  input {
    font-size: 1.25rem;
    width: 74px;
    height: 36px;
    text-align: center;
    border-bottom: 2px solid $secondary-color;
    border-top: none;
    color: $primary-text-color;
    border-left: none;
    border-right: none;
    background-color: rgba(206, 20, 49, 0.15);
    &:focus {
      outline: none;
    }
    &.touched {
      border-bottom-color: $primary-text-color;
      background-color: #fff;
    }
  }
  &.show-status {
    &.right {
      input {
        border-bottom-color: #1bb91f;
        background-color: #fff;
        color: #1bb91f;
      }
    }
    &.wrong {
      input {
        border-bottom-color: #ff1010;
        background-color: rgba(253, 88, 42, 0.15);
        color: #ff1010;
      }
    }
  }
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>
